;
if(!window.inits) {
    window.inits = [];
}
window.inits.push('initMondayReports()');

window.initMondayReports = () => {

    $('.icon-trash.monday').each(function(i, el) {
        var dlg = $('<div id="dialog-confirm" title="Bericht Löschen?"><p><span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 20px 0;"></span>Der Bericht wird permanent gelöscht. Sind Sie sich sicher?</p></div>');

        $(el).click(function(event) {
            var ref = $(this).attr('data-ref');
            var $row = $(this).closest('.row');
            dlg.dialog({
                resizable: false,
                height: 150,
                modal: true,
                buttons: {
                    "Löschen": function() {
                        go(ref, $row);
                        $(this).dialog("close");
                    },
                    "Abbrechen": function() {
                        $(this).dialog("close");
                    }
                }
            });

        });
    });

    function go(ref, row) {
        $.ajax({
            cache: false,
            type: "POST",
            url: '/Handler/HvD/Montagsbericht',
            data: {
                data: {
                    'ref': ref
                }
            }
        }).done(function(data) {

            if (data === 'ok') {
                row.remove();
            }
        });
    }
}
